import { gql } from "graphql-request";

export const fragmentPageLink = gql`
  fragment PageLink on pages {
    translations {
      languages_code {
        code
      }
      slug
    }
  }
`

export const fragmentMedia = gql`
  fragment Media on directus_files {
    id
    type
    mirrorable
    translations {
      languages_code {
        code
      }
      media_description
    }
  }
`

export const fragmentLink = gql`
  ${fragmentPageLink}

  fragment Link on link {
    type
    page {
      ...PageLink
    }
    link
    product
    collection
    new_tab
    parameters
    icon  {
      id,
      type,
      mirrorable
      translations {
        languages_code {
          code
        }
        media_description
      }
    }
    translations {
      languages_code {
        code
      }
      display_text
    }
  }
`